class ProductGridCount extends window.BAO.CustomElement({
  SuperClass: HTMLParagraphElement,
}) {
  constructor () {
    super()

    this.state = {
      root: window.theme.category
        ? window.theme.category.stateLayer.state
        : window.theme.searchResults.stateLayer.state,
    }

    this.eventBus = window.theme.category
      ? window.theme.category.eventBus
      : window.theme.searchResults.eventBus
  }

  connectedCallback () {
    this.subscribeToEvents()

    this.setAttribute('hidden', 'true')
    this.textContent = `${this.totalProducts} products`
  }

  subscribeToEvents () {
    this.eventBus.subscribe('state:totalProducts:updated', () => {
      this.textContent = `${this.totalProducts} ${window.theme.strings.collection.products}`
      this.removeAttribute('hidden')
      this.renderViewDependantOnResults()
    })
  }

  renderViewDependantOnResults () {
    if (window.theme.searchResults) {
      const resultsHeader = document.querySelector('.clc-ResultsHeader')
      const noResultsHeader = document.querySelector('.clc-NoResultsHeader')
      const productGrid = document.querySelector('.clc-ProductGrid')
      const searchBar = document.querySelector('.hd-Search')

      if (this.totalProducts === 0) {
        resultsHeader.setAttribute('hidden', 'true')
        noResultsHeader.removeAttribute('hidden')
        productGrid.setAttribute('hidden', 'true')
        searchBar.setAttribute('aria-hidden', 'false')
        document.body.classList.add('lyt-Header-searchVisible')
        document.body.classList.add('lyt-KlevuOpen')
      } else {
        resultsHeader.removeAttribute('hidden')
        noResultsHeader.setAttribute('hidden', 'true')
        productGrid.removeAttribute('hidden')
        searchBar.setAttribute('aria-hidden', 'true')
        document.body.classList.remove('lyt-Header-searchVisible')
        document.body.classList.remove('lyt-KlevuOpen')
      }
    }
  }

  get totalProducts () {
    return this.state.root.totalProducts || 0
  }
}

customElements.define('product-grid-count', ProductGridCount, {
  extends: 'p',
})
